/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Enough to link from a submission to its upload batch report.
 * @export
 * @interface SubmissionBatchRef
 */
export interface SubmissionBatchRef {
    /**
     * 
     */
    batchId: string;
    /**
     * 
     */
    senderName: string | null;
    /**
     * 
     */
    expectedCount: number;
}

/**
 * Check if a given object implements the SubmissionBatchRef interface.
 */
export function instanceOfSubmissionBatchRef(value: object): value is SubmissionBatchRef {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if ((!('senderName' in (value as Record<string, any>)) && !('sender_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['senderName'] === undefined && (value as Record<string, any>)['sender_name'] === undefined)) return false;
    if ((!('expectedCount' in (value as Record<string, any>)) && !('expected_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['expectedCount'] === undefined && (value as Record<string, any>)['expected_count'] === undefined)) return false;
    return true;
}

export function SubmissionBatchRefFromJSON(json: any): SubmissionBatchRef {
    return SubmissionBatchRefFromJSONTyped(json, false);
}

export function SubmissionBatchRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionBatchRef {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'senderName': json['sender_name'],
        'expectedCount': json['expected_count'],
    };
}

export function SubmissionBatchRefToJSON(json: any): SubmissionBatchRef {
    return SubmissionBatchRefToJSONTyped(json, false);
}

export function SubmissionBatchRefToJSONTyped(value?: SubmissionBatchRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
        'sender_name': value['senderName'],
        'expected_count': value['expectedCount'],
    };
}

